import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

export const resolveImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http") || url.startsWith("data:") || url.startsWith("blob:")) return url;
  return `${BACKEND_URL}${url}`;
};

export const api = {
  list: () => axios.get(`${API}/inventory`).then((r) => r.data),
  create: (item) => axios.post(`${API}/inventory`, item).then((r) => r.data),
  createBatch: (items) =>
    axios.post(`${API}/inventory/batch`, { items }).then((r) => r.data),
  update: (id, updates) =>
    axios.put(`${API}/inventory/${id}`, updates).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/inventory/${id}`).then((r) => r.data),
  bulkDelete: (ids) =>
    axios.post(`${API}/inventory/bulk-delete`, { ids }).then((r) => r.data),
  importFile: (file) => {
    const form = new FormData();
    form.append("file", file);
    return axios
      .post(`${API}/inventory/import`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
  clear: () => axios.delete(`${API}/inventory`).then((r) => r.data),
  analyze: (fileList) => {
    const form = new FormData();
    Array.from(fileList).forEach((f) => form.append("files", f));
    return axios
      .post(`${API}/scan/analyze`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
  analyzeOne: (file, config, multi = false) => {
    const form = new FormData();
    form.append("files", file);
    if (config) form.append("config", JSON.stringify(config));
    form.append("multi", multi ? "true" : "false");
    return axios
      .post(`${API}/scan/analyze`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
};
